// extracted by mini-css-extract-plugin
module.exports = {"list":"bloglist-module--list--2GOEg","list__hero":"bloglist-module--list__hero--lTLp8","list__info":"bloglist-module--list__info--NFYym"};